namespace GeniuzPOS.Lookups {
    export interface LookupCategoryRow {
        CatCode?: string;
        CatName?: string;
    }

    export namespace LookupCategoryRow {
        export const idProperty = 'CatCode';
        export const nameProperty = 'CatCode';
        export const localTextPrefix = 'Lookups.LookupCategory';
        export const lookupKey = 'Lookups.LookupCategory';

        export function getLookup(): Q.Lookup<LookupCategoryRow> {
            return Q.getLookup<LookupCategoryRow>('Lookups.LookupCategory');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CatCode = "CatCode",
            CatName = "CatName"
        }
    }
}
